import styled from "styled-components";

/* Under the address field: a short hint, or whether the address is available */
export const AddressStatus = styled.p<{ $available?: boolean }>`
  margin-top: -0.25rem;
  font-family: Inter, sans-serif;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${props =>
    props.$available === undefined
      ? "var(--color-neutral-150)"
      : props.$available
        ? "var(--color-feedback-success)"
        : "var(--color-feedback-danger)"};

  &.checking {
    display: flex;
    gap: 0.375rem;
    align-items: center;

    /* The loader (24px with its arc) doesn't make the line taller than the text: no jump when it goes */
    > span {
      margin: -4px 0;
    }
  }
`;
